// AOSM Collection — Filtres + Tri
(function () {

  const grid    = document.getElementById('aosm-grid');
  const filters = document.getElementById('aosm-filters');
  const sort    = document.getElementById('aosm-sort');

  if (!grid || !filters) return;

  // ── FILTRES ──────────────────────────────────────────────
  filters.addEventListener('click', function (e) {
    const btn = e.target.closest('.aosm-cl__pill');
    if (!btn) return;

    filters.querySelectorAll('.aosm-cl__pill').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');

    const filter = btn.dataset.filter;
    const cards  = grid.querySelectorAll('.aosm-cl__card');

    cards.forEach(function (card) {
      if (filter === 'all') {
        card.style.display = '';
      } else {
        card.style.display = card.classList.contains(filter) ? '' : 'none';
      }
    });
  });

  // ── TRI ───────────────────────────────────────────────────
  if (sort) {
    const params  = new URL(window.location.href).searchParams;
    const current = params.get('sort_by');
    if (current) sort.value = current;

    sort.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // ── STICKY TOOLBAR ────────────────────────────────────────
  const toolbar = document.getElementById('aosm-toolbar');
  if (toolbar) {
    const sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    toolbar.before(sentinel);
    new IntersectionObserver(
      ([entry]) => toolbar.classList.toggle('is-sticky', !entry.isIntersecting),
      { threshold: 0 }
    ).observe(sentinel);
  }

})();